export default __webpack_public_path__ + "static/media/generic_error_robot.62e64122.png";